// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#notifications-list[data-v-dc8970c8]{max-height:600px;overflow-y:auto}#read-messages[data-v-dc8970c8]{color:rgba(0,0,0,.55)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
